import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Col, Panel, Row } from 'react-bootstrap';

import { startsWith } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import LocationOptions from './location_options';
import LocationForm from './location_form';
import LocationMap from './location_map';
import { NEW_LOCATION_ID_PREFIX } from './locations_constants';
import ManagedInput from 'components/form/managed_input';

const LocationPanel = ({ fullWidthMap, location, isOpen, stateOptions, googleMapsApiKey,
  onHeaderClick, onLocationChange, onRemove }) => {
  const clearBtnRef = useRef(null);

  const gePanelTitle = () => {
    const doNotHaveLocationInfo = !location.city && !location.state && !location.zip;
    if (location.name) return location.name;
    else if (location.polygonSearch) return 'Map Drawing';
    else if (startsWith(location.id, NEW_LOCATION_ID_PREFIX) && doNotHaveLocationInfo) return 'New Location';
    else if (doNotHaveLocationInfo) return 'No Location';

    const stateZip = [location.state, location.zip].filter(str => !!str).join(' ');
    return [location.city, stateZip].filter(str => !!str).join(', ');
  };

  const handleHeaderClick = () => {
    onHeaderClick && onHeaderClick(location.id);
  };

  const polygonSearch = location.polygonSearch;
  const panelTitle = gePanelTitle(location);

  return (
    <Panel eventKey={location.id}>
      <Panel.Heading className={'d-flex justify-content-between clickable'}
        onClick={handleHeaderClick}
      >
        <Panel.Title>{panelTitle}</Panel.Title>
        <FontAwesomeIcon className={'mt-1 clickable'} icon={faTrash} size="lg"
          onClick={() => onRemove && onRemove(location.id)}
        />
      </Panel.Heading>
      <Panel.Body collapsible>
        <div className="form-group">
          <label className="control-label">Name</label>
          <div className="form-input-container">
            <ManagedInput
              className="form-control"
              name="name"
              placeholder="Location Name"
              value={location.name}
              onChange={({ name }) => onLocationChange({ ...location, name: name })}
            />
          </div>
        </div>
        <Row>
          <Col md={fullWidthMap ? 12 : 4}>
            <LocationOptions
              clearBtnRef={clearBtnRef}
              location={location}
              onLocationChange={onLocationChange}
            />
          </Col>
          <Col
            className="bg-white left-top-border"
            md={fullWidthMap ? 12 : 8}
          >
            {polygonSearch ?
              (isOpen &&
                <LocationMap
                  clearBtnRef={clearBtnRef}
                  googleMapsApiKey={googleMapsApiKey}
                  location={location}
                  onPolygonChange={newPolygon => onLocationChange({
                    ...location,
                    polygonGeojson: newPolygon
                  })}
                />) :
              <LocationForm location={location} stateOptions={stateOptions}
                onLocationChange={onLocationChange}
              />}
          </Col>
        </Row>
      </Panel.Body>
    </Panel>
  );
};

LocationPanel.propTypes = {
  fullWidthMap: PropTypes.bool,
  googleMapsApiKey: PropTypes.string,
  isOpen: PropTypes.bool,
  location: PropTypes.object.isRequired,
  stateOptions: PropTypes.array.isRequired,
  onHeaderClick: PropTypes.func,
  onLocationChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func,
};

export default LocationPanel;
